import React from 'react'

import { COMPONENT_EXTENDER } from 'extender'

const NavBannerLayout = COMPONENT_EXTENDER('components/layouts/NavBannerLayout')
const ResetPasswordComponent = COMPONENT_EXTENDER('components/core/Forms/ResetPasswordForm/ResetPasswordForm-component')

const ResetPasswordPage = () => (
    <NavBannerLayout signPage="forgotpassword">
        <ResetPasswordComponent />
    </NavBannerLayout>
)

export default ResetPasswordPage
